import { createErrorComponent } from "components/Errors/ErrorComponent";
import { useStompClient } from "react-stomp-hooks";
import { StompFilter } from "./StompComponent";

export type SubscriptionInfos = {
  subbedEvent: string;
  pathFilter?: string;
  filters?: StompFilter[];
};

const SUBSCRIPTION_DESTINATION = "/to-applicat/events/subscribe";

export function SubscriptionSocket(subscriptionInfos: SubscriptionInfos) {
  const stompClient = useStompClient();
  const eventSub = {
    eventType: subscriptionInfos.subbedEvent,
    jsonPathFilter: subscriptionInfos.pathFilter,
    filters: subscriptionInfos.filters,
  };

  const sendMessage = () => {
    if (stompClient) {
      stompClient.publish({
        destination: SUBSCRIPTION_DESTINATION,
        body: JSON.stringify(eventSub),
      });
    } else {
      const errorMessage =
        "Erreur lors de la souscription à " + subscriptionInfos.subbedEvent;

      return createErrorComponent(undefined, errorMessage);
    }
  };
  sendMessage();
  return null;
}
